import hyRequest from './index'
import { IDataType } from './types'

// 登录方法
export function login(username: string, password: string, code: string, uuid: string) {
  return hyRequest.post<IDataType>({
    url: '/auth/login',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    data: { username, password, code, uuid }
  })
}

// 注册方法
export function register(data: any) {
  return hyRequest.post<IDataType>({
    url: '/auth/register',
    headers: {
      isToken: false
    },
    data: data
  })
}

// 刷新方法
export function refreshToken(token: string) {
  return hyRequest.post<IDataType>({
    url: '/auth/refresh',
    data: { token }
  })
}

// 获取用户详细信息
export function getInfo() {
  return hyRequest.get<IDataType>({
    url: '/system/user/getInfo'
  })
}

// 退出方法
export function logout(token: string) {
  return hyRequest.delete<IDataType>({
    url: '/auth/logout'
  })
}

// 获取验证码
export function getCodeImg() {
  return hyRequest.get<IDataType>({
    url: '/code',
    headers: {
      isToken: false
    },
    timeout: 20000
  })
}